const state = {
  completedExams: localStorage.gameCompletedExams ? JSON.parse(localStorage.gameCompletedExams) : [],
}

const getters = {
  completeAllExam (state) {
    return Array.from(new Set(state.completedExams)).length === 3
  },
}

const mutations = {
  setCompletedExams (state, value) {
    state.completedExams = value
    localStorage.gameCompletedExams = JSON.stringify(value)
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
